import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { PROJECT_KEYS } from '@/features/projects/public';
import { projectTemplatesService } from '../api/project-templates.service';

/** Creates a project + initial board from a template (system preset or tenant-owned). */
export function useInstantiateProjectTemplate() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (templateId: string) => projectTemplatesService.instantiate(templateId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PROJECT_KEYS.byOrg(orgId ?? '') });
    },
  });
}
